import { useTranslation } from "react-i18next"
import { useRecoilState } from "recoil"
import { Button } from "../App.styles"
import { Typography } from "@material-ui/core"
import EmptyPage from "../common/EmptyPage"
import { ReactComponent as SearchEmpty } from "../images/search-empty.svg"
import { termState, timingState } from "./Organize.state"
import { getChallengeTimingLabel, isTimingFilterActive } from "./Organize.utilities"

const OrganizeSearchEmpty = () => {
    const { t } = useTranslation()
    const [term, setTerm] = useRecoilState(termState)
    const [timing, setTiming] = useRecoilState(timingState)
    const hasTimingFilter = isTimingFilterActive(timing)

    const onClearFilters = () => {
        setTerm("")
        setTiming(null)
    }

    const message = term
        ? (
            <>
                {t('No challenges found for search term:')} <strong>"{term}"</strong>
            </>
        )
        : hasTimingFilter
            ? (
                <>
                    {t('No challenges found for Challenge Timing:')} <strong>"{getChallengeTimingLabel(timing)}"</strong>
                </>
            )
            : t('No challenges found')

    const clearLabel = term && hasTimingFilter
        ? t('Clear Filters')
        : hasTimingFilter
            ? t('Clear Filter')
            : t('Clear Search')

    return (
        <EmptyPage>
            <SearchEmpty />
            <div>
                <Typography className="text-center mb-4">
                    {message}
                </Typography>
                <Button 
                    data-testid="challenge__clear-search" 
                    size="lg" 
                    className="btn--flat btn--flat-sm d-block w-100" 
                    color="primary" 
                    onClick={onClearFilters}
                >
                    {clearLabel}
                </Button>
            </div>
        </EmptyPage>
    )
}

export default OrganizeSearchEmpty
